import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { InfoIcon, XCloseIcon } from '@rsos/assets/icons';
import Popover from '@rsos/components/capstone/base/Popover';
import Text from '@rsos/components/capstone/base/Text';

const BubbleArrow = styled.div`
  &::before {
    content: ' ';
    height: 10px;
    width: 10px;
    background: ${({ theme }) => theme.colors.background};
    position: absolute;
    border: 1px solid ${({ theme }) => theme.colors.heavyLineOutline};
    top: ${({ arrowOffset }) => arrowOffset}px;
    left: -5px;
    transform: rotate(45deg);
    z-index: 5;
  }
  &::after {
    content: ' ';
    height: 10px;
    width: 10px;
    background: ${({ theme }) => theme.colors.background};
    position: absolute;
    border: 1px solid transparent;
    top: ${({ arrowOffset }) => arrowOffset}px;
    left: -4px;
    transform: rotate(45deg);
    z-index: 10;
  }
`;

const Bubble = styled.div`
  position: absolute;
  background: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.primaryText};
  padding: 17px 20px;
  z-index: 6;
  border: 1px solid ${({ theme }) => theme.colors.heavyLineOutline};
  width: 225px;
  border-radius: 4px;
`;

const Title = styled(Text).attrs({
  size: 'normal',
  fontWeight: 'bold',
})`
  margin-bottom: 10px;
`;

const Description = styled(Text).attrs({
  size: 'small',
  color: 'secondaryLink',
})``;

const IconButton = styled.button`
  background: transparent;
  padding: 0;
  margin: 0;
  outline: 0;
  border: 0;
  line-height: 0px;
  display: inline-block;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.secondaryLink};
`;

const CloseButton = styled(IconButton)`
  position: absolute;
  right: 10px;
  top: 10px;
`;

const InfoTooltip = ({ cardBodyRef }) => {
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    if (!cardBodyRef.current) {
      return;
    }
    const currentCardBodyRef = cardBodyRef.current;
    const h = () => {
      if (isOpen) {
        setIsOpen(false);
      }
    };
    currentCardBodyRef.addEventListener('scroll', h);
    return () => {
      currentCardBodyRef.removeEventListener('scroll', h);
    };
  }, [cardBodyRef, isOpen]);

  const arrowOffset = 40;
  const arrowSide = 7;
  const arrowDiagonal = arrowSide * Math.sqrt(2);

  const xOffset = arrowDiagonal;
  const yOffset = arrowOffset + arrowSide / 2;

  return (
    <Popover
      popoverID="info-tooltip"
      isOpen={isOpen}
      xOffset={xOffset}
      yOffset={yOffset}
      trigger={
        <IconButton onClick={() => setIsOpen(prev => !prev)}>
          <InfoIcon height={16} width={16} />
        </IconButton>
      }
    >
      <BubbleArrow arrowOffset={arrowOffset}>
        <Bubble>
          <CloseButton onClick={() => setIsOpen(false)}>
            <XCloseIcon />
          </CloseButton>
          <Title>What is an Emergency Response Area?</Title>
          <Description>
            This location is estimated when the device detects that the user may
            be placing a call from (or nearby) a known location.
          </Description>
        </Bubble>
      </BubbleArrow>
    </Popover>
  );
};

export default InfoTooltip;
